module.exports = __webpack_public_path__ + "static/media/grooming.3889f9a6.svg";